import axios from 'axios';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_TRANSPORTEURS_REQUEST: 'FETCH_TRANSPORTEURS_REQUEST',
    FETCH_TRANSPORTEURS_SUCCESS: 'FETCH_TRANSPORTEURS_SUCCESS',
    FETCH_TRANSPORTEURS_FAILURE: 'FETCH_TRANSPORTEURS_FAILURE',

    FETCH_SUGGESTIONS_TRANSPORTEUR_REQUEST: 'FETCH_SUGGESTIONS_TRANSPORTEUR_REQUEST',
    FETCH_SUGGESTIONS_TRANSPORTEUR_SUCCESS: 'FETCH_SUGGESTIONS_TRANSPORTEUR_SUCCESS',
    FETCH_SUGGESTIONS_TRANSPORTEUR_FAILURE: 'FETCH_SUGGESTIONS_TRANSPORTEUR_FAILURE',

    CLEAR_SUGGESTIONS_TRANSPORTEUR: 'CLEAR_SUGGESTIONS_TRANSPORTEUR',

    SET_TRANSPORTEUR_VALUE: 'SET_TRANSPORTEUR_VALUE',
    CLEAR_TRANSPORTEUR_VALUE: 'CLEAR_TRANSPORTEUR_VALUE'


};


/**
 * FETCH_TRANSPORTEURS
 * ActionCreator pour la récupération des transporteurs
 */
const fetchTransporteursRequest = () => ({ type: Actions.FETCH_TRANSPORTEURS_REQUEST });
const fetchTransporteursSuccess = items => ({ type: Actions.FETCH_TRANSPORTEURS_SUCCESS, items });
const fetchTransporteursFailure = error => ({ type: Actions.FETCH_TRANSPORTEURS_FAILURE, error });

export const fetchTransporteurs = () => (dispatch, getState) => {
    
    if (getState().transporteur.transporteurs.isLoading) {
        return;
    }
    if (getState().transporteur.transporteurs.items.length > 0) {
        return;
    }
    return dispatch(_fetchTransporteurs());
};


const _fetchTransporteurs = () => async (dispatch) => {

    dispatch(fetchTransporteursRequest());

    try {
        let response = await axios.get('api/transporteurs');
        dispatch(fetchTransporteursSuccess(response.data));
    } catch (error) {
        console.error('fetchTransporteurs : ', error);
        dispatch(fetchTransporteursFailure(error));
    }

};




/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsTransporteurRequest = () => ({
    type: Actions.FETCH_SUGGESTIONS_TRANSPORTEUR_REQUEST
});
const fetchSuggestionsTransporteurSuccess = transporteurs => ({
    type: Actions.FETCH_SUGGESTIONS_TRANSPORTEUR_SUCCESS,
    transporteurs
});
const fetchSuggestionsTransporteurFailure = error => ({
    type: Actions.FETCH_SUGGESTIONS_TRANSPORTEUR_FAILURE,
    error
});

/**
 * ActionCreator pour la récuperation des données (suggestions)
 */
export const fetchSuggestionsTransporteur = (searchValue) => async (dispatch) => {
    dispatch(fetchSuggestionsTransporteurRequest());

    try {
        let response = await axios.get('api/transporteurs/suggestion?query=' + searchValue);

        dispatch(fetchSuggestionsTransporteurSuccess(response.data));

    } catch (error) {
        dispatch(fetchSuggestionsTransporteurFailure(error));
    }
};

/**
 * ActionCreator pour CLEAR_SUGGESTIONS_TRANSPORTEUR
 */
export const clearSuggestionsTransporteur = () => ({ type: Actions.CLEAR_SUGGESTIONS_TRANSPORTEUR });



/**
 * ActionCreator pour SET_TRANSPORTEUR_VALUE
 */
export const setTransporteurValue = (value, selectedId) => ({ type: Actions.SET_TRANSPORTEUR_VALUE, value, selectedId });

/**
 * ActionCreator pour CLEAR_TRANSPORTEUR_VALUE
 */
export const clearTransporteurValue = () => ({ type: Actions.CLEAR_TRANSPORTEUR_VALUE });

